import React, { useEffect, useState } from "react";
import { configurations } from "../../../configurations";
import CustomerDetailOrdersFlightList from "./CustomerDetailOrdersFlightList";
import CustomerDetailOrdersStayList from "./CustomerDetailOrdersStayList";
import CustomerDetailOrdersTourList from "./CustomerDetailOrdersTourList";
import CustomerDetailOrdersInsuranceList from "./CustomerDetailOrdersInsuranceList";
import getBookings from "../../../controllers/booking/getBookings";
import { useHotels } from "../../../hooks/useHotels";
import { useTours } from "../../../hooks/useTours";
import { useInsuranceApi } from "../../../hooks/useInsuranceApi";
import getUserFlightBookings from "../../../controllers/booking/getUserFlightBookings";

function CustomerDetailOrdersSection({ data }) {
  const { getHotelBookings } = useHotels();
  const { getTourBookings } = useTours();
  const { getInsuranceBookings } = useInsuranceApi();
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(configurations.services.flight.code);
  const [flightTotal, setFlightTotal] = useState(0);
  const [stayTotal, setStayTotal] = useState(0);
  const [tourTotal, setTourTotal] = useState(0);
  const [insuranceTotal, setInsuranceTotal] = useState(0);

  const tabs = [
    {
      label: configurations.services.flight.label,
      code: configurations.services.flight.code,
      count: flightTotal,
    },
    {
      label: configurations.services.stay.label,
      code: configurations.services.stay.code,
      count: stayTotal,
    },
    {
      label: configurations.services.tour.label,
      code: configurations.services.tour.code,
      count: tourTotal,
    },
    {
      label: configurations.services.insurance.label,
      code: configurations.services.insurance.code,
      count: insuranceTotal,
    },
  ];

  const loadData = async () => {
    setLoading(true);
    const requests = [
      getUserFlightBookings({ limit: 1, id: data?._id }).then((res) => {
        if (res?.data?.meta?.total) {
          setFlightTotal(res?.data?.meta?.total);
        }
      }),
      getHotelBookings({ limit: 1, account: data?._id }).then((res) => {
        const [_, total] = res;
        setStayTotal(total);
      }),
      getTourBookings({ limit: 1, account: data?._id }).then((res) => {
        const [_, total] = res;
        setTourTotal(total);
      }),
      getInsuranceBookings({ limit: 1, account: data?._id }).then((res) => {
        const [_, total] = res;
        setInsuranceTotal(total);
      }),
    ];

    await Promise.all(requests).finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, []);

  const OrderTable = () => {
    switch (tab) {
      case configurations.services.flight.code:
        return <CustomerDetailOrdersFlightList data={data} />;
      case configurations.services.stay.code:
        return <CustomerDetailOrdersStayList data={data} />;
      case configurations.services.tour.code:
        return <CustomerDetailOrdersTourList data={data} />;
      case configurations.services.insurance.code:
        return <CustomerDetailOrdersInsuranceList data={data} />;
      default:
        return <></>;
    }
  };

  return (
    <div className="w-full flex p-4 flex-col">
      <div className="w-full flex items-center gap-2 overflow-x-scroll scroll-hide">
        {tabs?.map((item, itemIndex) => {
          const isSelected = tab === item.code;
          return (
            <button
              key={itemIndex}
              className={`h-12 px-4 gap-2 rounded-md items-center justify-center flex text-sm font-semibold ${
                isSelected
                  ? "text-white bg-[#4E5662]"
                  : "text-[#6D7C94] bg-[#F8F8F8]"
              }`}
              onClick={() => setTab(item.code)}
            >
              <span>{item.label}s</span>
              {loading ? (
                <>
                  {isSelected ? (
                    <div className="buttonLoader"></div>
                  ) : (
                    <div className="primaryLoader"></div>
                  )}
                </>
              ) : (
                <span
                  className={`flex items-center justify-center py-1 rounded-md px-2 text-xs font-semibold ${
                    isSelected
                      ? "text-[#47A0FA] bg-[#5F6978]"
                      : "text-[#6D7C94] bg-[#F1F1F1]"
                  }`}
                >
                  {item.count}
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="w-full mt-2">
        <OrderTable />
      </div>
    </div>
  );
}

export default CustomerDetailOrdersSection;
